import React,{useState,useEffect,useRef} from 'react';
import "./RequestsDetail.scss";
import {
    addPrescriptionsComments_api,
    getRequestDetail_api,
    getRequests_api,
    prescriptionsCommentsList_api,
    SendPresFile
} from "../../Services/apis";
import {useHistory, useParams} from "react-router-dom";
import {Spin} from "antd";
import toaster from "toasted-notes";
import moment from "moment-jalaali";
import {SendFile} from "../Chat/ChatServices";
import useOnScreen from "../../hooks/useOnScreen";

let globParent = null


function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


let lastComment = null
let pagei = 1;


function MeCommentCard({comment,getCommentListPaginate}){
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);

    const [vis,set_vis] = useState(false);


    useEffect(()=>{
        if(!vis && isVisible && lastComment && comment.uid===lastComment.uid){
            pagei = pagei+1;
            getCommentListPaginate()
            set_vis(true)
            console.log("page next")
        }
    },[isVisible])

    return(
        <div className="me-comment-text-item" ref={ref}>
            <div className="me-comment">
                <span className="comment-text">{comment.comment}</span>
                <span className="comment-date">{moment(comment.created).format("jYYYY-jMM-jDD HH:mm")}</span>
            </div>
        </div>
    )
}


function AdminCommentCard({comment,getCommentListPaginate}){
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);

    const [vis,set_vis] = useState(false);


    useEffect(()=>{
        if(!vis && isVisible && lastComment && comment.uid===lastComment.uid){
            pagei = pagei+1;
            getCommentListPaginate()
            set_vis(true)
            console.log("page next")
        }
    },[isVisible])

    return(
        <div className="admin-comment-text-item" ref={ref}>
            <div className="admin-comment">
                <span className="comment-text">{comment.comment}</span>
                <span className="comment-date">{moment(comment.created).format("jYYYY-jMM-jDD HH:mm")}</span>
            </div>
        </div>
    )
}


function RequestsDetail(){

    const [results,set_results] = useState([])
    const {id}  = useParams()
    const history  = useHistory();

    useEffect(()=>{
        lastComment = null
         pagei = 1;
        getResults()
        getComments()
    },[])


    const goTo = async (url)=>{
        window.open(url, "_blank")
    }

    const getResults = async ()=>{
        try{
          const res = await getRequestDetail_api()
        }catch(e){
            console.error(e)
        }
    }
    const getComments = async ()=>{
        try{
            const res = await prescriptionsCommentsList_api(id,pagei)
            set_results(list=>[...list,...res.data.results])
            if(res.data.results.length > 8){
                lastComment = res.data.results[res.data.results.length-1]
                console.log("lastCommentl",lastComment)
            }
            // set_results(res.data.results)
        }catch(e){
            console.error(e)
        }
    }


    const convertStatus = (st)=>{
        switch(st){
            case "pending":
                return "منتظر تایید"
                break;
            case "ready_to_pay":
                return "منتظر پرداخت"
                break;
            default:
                return ""
        }
    }

    const [text,set_text] = useState("")

    const addComment = async ()=>{

        if(text.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"پیام خالی می باشد"}/>),{duration: 2000});
            return false
        }

        let obj ={
            parent: globParent,
            comment: text
        }

        try{
            const res = await addPrescriptionsComments_api(id,obj)
            pagei = 1;
            set_results([])
            getComments()
            set_text("")
        }catch(e){
            console.error(e)
        }
    }

    const onEnter = (event, callback) => event.key  === 'Enter' && callback();
    const enterEvent = () => addComment();


    const Fio = async ()=>{
        try{
            const res = await SendPresFile()
        }catch (e) {
            console.error(e)
        }
    }


    const fileUpload = async () =>{
        let file = {}
        let file1 = {}
        let file2 = {}
        try{
            //start loading
            const formData = new FormData();
            formData.append('file', file);
            formData.append('file', file1);
            formData.append('file', file2);
            const response = await SendPresFile(formData,id)
        }catch (e) {
            //end loading
            console.log(e);
        }
    }




    return(
        <div className="results-container">
            <div className="customer-header">
                <span>{"جزییات خدمات"}</span>
                <i style={{right:25}} onClick={()=>{
                    history.goBack();
                }}
                   className="fa fa-arrow-right"></i>
            </div>
            <br/>
            <br/>
            <br/>
            <div className="comment-list">
                {results.map(comment=>{
                    return(
                        <div>
                            {comment.added_by===1?
                                <AdminCommentCard  comment={comment} getCommentListPaginate={getComments}/>:
                                <MeCommentCard  comment={comment} getCommentListPaginate={getComments}/>
                            }
                        </div>

                    )
                })}

            </div>
            <div className="comment-send-box">
                <input
                    value={text}
                    onKeyPress={e => onEnter(e, enterEvent)}
                    onChange={(e)=>{set_text(e.target.value)}}
                    placeholder="پیام" type="text" name="" id=""/>
                <div className="send-btn"  onClick={addComment}>
                    <img src="/other/send-icon.png" alt=""/>
                </div>
                {/*<div className="send-btn attached" >*/}
                {/*    <img src="/other/attached-icon.png" alt=""/>*/}
                {/*</div>*/}
            </div>

        </div>
    )
}

export default RequestsDetail;
